import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { fmtRel } from "@/lib/fmt";
import { useConfirm } from "@/components/ConfirmDialog";

export default function GoogleAccounts({ isAdmin }) {
  const [rows, setRows] = useState([]);
  const { confirm } = useConfirm();
  const [params, setParams] = useSearchParams();
  const load = () => api.get("/google/accounts").then((r) => setRows(r.data.rows));
  useEffect(() => {
    load();
    const g = params.get("google");
    if (g === "ok") toast.success(`Connected ${params.get("email")}`);
    if (g === "error") toast.error(`Google connection failed: ${params.get("reason")}`);
    if (g) setParams({});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const connect = async () => {
    try {
      const { data } = await api.get("/oauth/google/start", { params: { origin: window.location.origin } });
      window.location.href = data.url;
    } catch (e) { toast.error(e.response?.data?.detail || "Could not start Google sign-in"); }
  };
  const remove = async (email) => {
    if (!(await confirm({ title: `Disconnect ${email}?`, body: "Forms stop booking on this calendar and its emails disappear from lead panels.", danger: true, okLabel: "Disconnect" }))) return;
    await api.delete(`/google/accounts/${email}`); load();
  };

  return (
    <section className="panel p-4" data-testid="google-accounts">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          <h2 className="text-sm font-medium">Google Calendar · Meet</h2>
          <div className="text-[11px] text-neutral-500 mt-0.5">Each @thickandthin.media mailbox signs in once. Forms check free/busy and create Meet invites; the lead panel reads and sends Gmail.</div>
        </div>
        {isAdmin && <button className="btn btn-primary shrink-0" onClick={connect} data-testid="google-connect-btn">Connect mailbox</button>}
      </div>
      {!rows.length ? <div className="text-xs text-neutral-600" data-testid="google-none">No mailboxes connected yet.</div> : (
        <div className="divide-y divide-[var(--border)]">
          {rows.map((r) => (
            <div key={r.email} className="flex items-center gap-3 py-2 text-sm" data-testid={`google-acc-${r.email}`}>
              <span className="dot dot-ok" /><span className="font-mono text-xs flex-1 truncate">{r.email}</span>
              <span className="pill pill-ok">Calendar</span>
              <span className={`pill ${(r.scope || "").includes("gmail") ? "pill-ok" : "pill-warn"}`} data-testid={`google-gmail-${r.email}`}>{(r.scope || "").includes("gmail") ? "Gmail" : "Gmail not granted"}</span>
              <span className="text-[11px] text-neutral-500 hidden sm:inline">connected {fmtRel(r.connected_at)}</span>
              {isAdmin && !(r.scope || "").includes("gmail") && <button className="btn text-xs" onClick={connect} data-testid={`google-reconnect-${r.email}`}>Reconnect</button>}
              {isAdmin && <button className="btn-ghost text-xs px-2 hover:text-[var(--breach)]" onClick={() => remove(r.email)} data-testid={`google-remove-${r.email}`}>Disconnect</button>}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
